import React from "react";
import { FormField } from "../../molecules/FormField/FormField";
import { Button } from "../../atoms/Button/Button";
import { Notification } from "../../molecules/Notification/Notification";
import useLogin from "../../../features/Login/application/useLogin";

export const LoginForm: React.FC = () => {
  const {
    handleSubmit,
    setFormData,
    clearLoginError,
    setFormDataError,
    data,
  } = useLogin();

  // Un manejador de cambios genérico para simplificar los inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormDataError({
      ...data.formDataError,
      [name]: false,
    });
    setFormData({
      ...data.formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  return (
    <>
    
      <form className="card w-full max-w-md">
        <FormField
          label="Correo electrónico"
          id="email"
          type="text"
          placeholder="Tu@correo.com"
          value={data.formData.email}
          name="email"
          error={data.formDataError.email}
          onChange={handleChange}
        />

        <FormField
          label="Contraseña"
          id="password"
          type="password"
          placeholder="Tu contraseña"
          name="password"
          value={data.formData.password}
          error={data.formDataError.password}
          onChange={handleChange}
        />

        <Button color="primary" type="button" onClick={handleSubmit}>
          Iniciar sesión
        </Button>
        <div className="mt-4 text-center">
          <a href="/forgot-password" className="text-sm text-primary hover:underline">
            ¿Olviaste tu contraseña?
          </a>
        </div>
      </form>
      {data.error.status && (
        <Notification
          message={data.error.message || "Ha ocurrido un error. Por favor, intenta de nuevo."}
          type="error"
          onClose={clearLoginError}
        />
      )}
    </>
  );
};
